import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';
import backgroundImage from '../../../assets/images/main/background_gradient_section.webp';

interface GradientSectionProps {
  title: string;
  subtitle: ReactNode;
  image: string;
  buttonText: string;
  onClick: () => void;
}

function GradientSection({
  title,
  subtitle,
  image,
  buttonText,
  onClick,
}: GradientSectionProps) {
  return (
    <Box
      sx={{
        borderRadius: '24px',
        padding: '20px',
        textAlign: 'center',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        m: '0 5px',
      }}
    >
      <Typography
        sx={{
          fontFamily: 'Avenir Next',
          fontWeight: 700,
          fontSize: '24px',
          color: '#fff',
          mb: '15px',
        }}
      >
        {title}
      </Typography>
      <img
        style={{
          width: '100%',
          height: 'auto',
          maxWidth: '343px',
          display: 'block',
          margin: '0 auto',
        }}
        src={image}
        alt="Main 1"
      />
      <Typography
        sx={{
          mt: '15px',
          fontFamily: 'Avenir Next',
          fontWeight: 400,
          fontSize: '16px',
          color: 'rgba(255, 255, 255, 0.60)',

          span: {
            fontWeight: 600,
            color: '#fff',
          },
        }}
      >
        {subtitle}
      </Typography>
      <button
        style={{
          cursor: 'pointer',
          background:
            'linear-gradient(270deg, #FF9A84 0%, #EF5DCE 50%, #2B42DB 100%)',
          fontSize: '16px',
          color: '#fff',
          fontWeight: 600,
          fontFamily: 'Avenir Next',
          textTransform: 'none',
          height: '52px',
          width: '100%',
          borderRadius: '12px',
          border: 'none',
          WebkitTapHighlightColor: 'transparent',
          marginTop: '16px',
        }}
        onClick={onClick}
      >
        {buttonText}
      </button>
    </Box>
  );
}

export default GradientSection;
